import React from 'react'
import EditIcon from 'assets/icons/edit-icon'
import RemoveIcon from 'assets/icons/remove-icon16px'
import EyeIcon from 'assets/icons/eye-2-line-icon'
import NominateIcon from 'assets/icons/nominate-icon'
import ViewIcon from 'assets/icons/view-icon'
import ReassessIcon from 'assets/icons/reassess-icon'
import { buildDetailsUrl } from 'routing/constants'
import { requestReassesSite, requestEditSite } from 'api/site'
import { showErrorToast } from 'utils/toast'
import {
  SITE_STATUS_CONFIRMED_ID,
  SITE_STATUS_DELISTED_ID,
  SITE_STATUS_DOES_NOT_QUALIFY,
  SITE_STATUS_DRAFT_ID,
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_REVIEWED_BY_RFP_ID,
} from '../siteStatuses'
import { getEditOnlyContext } from '../../utils/editOnlyContext'
import { compareHistoriesByReassessmentThenDate } from '../../utils/siteHistories'
import {
  createNavigateIndividualReviewedByRfp,
  createNavigateViewSiteWithAllHistories,
} from '../../utils/navigationHandlers'

function buildNcgDraftOrEditOnlyItems(site, history, setSiteForDeleting) {
  const { editOnlySite, editOnlySiteStatus } = getEditOnlyContext(site)
  return [
    {
      icon: <EditIcon />,
      title: 'edit',
      onClick: createNavigateIndividualReviewedByRfp(site, history, editOnlySite, editOnlySiteStatus),
    },
    {
      icon: <RemoveIcon />,
      title: 'Remove',
      onClick: () => {
        setSiteForDeleting(site)
      },
    },
  ]
}

function buildNcgReviewedByRfpItems(site, history, setSiteToWorkWith) {
  const { editOnlySite, editOnlySiteStatus } = getEditOnlyContext(site)
  return [
    {
      icon: <EyeIcon />,
      title: 'review',
      onClick: createNavigateIndividualReviewedByRfp(site, history, editOnlySite, editOnlySiteStatus),
    },
    {
      icon: <NominateIcon />,
      title: 'nominateSite',
      onClick: () => {
        setSiteToWorkWith(site)
      },
    },
  ]
}

function buildNcgConfirmedDelistedDnqItems(site, history) {
  const { editOnlySite } = getEditOnlyContext(site)
  return [
    {
      icon: <ViewIcon />,
      title: 'viewSite',
      onClick: () => {
        if (site.SitesHistories?.length > 0) {
          site.SitesHistories.sort(compareHistoriesByReassessmentThenDate)
          return history(buildDetailsUrl(site.id, site.SitesHistories[0].historyId, editOnlySite))
        }
        history(buildDetailsUrl(site.id))
      },
    },
    {
      icon: <ReassessIcon />,
      title: 'reassessSite',
      disabled: false,
      onClick: () => {
        requestReassesSite(site.id).then((data) => {
          if (data.error) {
            return showErrorToast(data.error, 'showBorder')
          }
          return history(buildDetailsUrl(site.id, data.historyId, editOnlySite))
        })
      },
    },
    {
      icon: <EditIcon />,
      title: 'editNow',
      disabled: false,
      onClick: () => {
        requestEditSite(site.id).then((data) => {
          if (data.error) {
            return showErrorToast(data.error, 'showBorder')
          }
          return history(buildDetailsUrl(site.id, data.historyId, editOnlySite))
        })
      },
    },
  ]
}

function buildNcgDefaultItems(site, history) {
  const { editOnlySite, editOnlySiteStatus } = getEditOnlyContext(site)
  return [
    {
      icon: <ViewIcon />,
      title: 'viewSite',
      onClick: createNavigateViewSiteWithAllHistories(site, history, editOnlySite, editOnlySiteStatus),
    },
  ]
}

export function buildNcgMenuItems(ctx) {
  const { site, history, setSiteToWorkWith, setSiteForDeleting } = ctx

  if ([SITE_STATUS_DRAFT_ID, SITE_STATUS_EDIT_ONLY_ID].includes(site.SiteStatus.id)) {
    return buildNcgDraftOrEditOnlyItems(site, history, setSiteForDeleting)
  }
  if (site.SiteStatus.id === SITE_STATUS_REVIEWED_BY_RFP_ID) {
    return buildNcgReviewedByRfpItems(site, history, setSiteToWorkWith)
  }
  if (
    site.SiteStatus.id === SITE_STATUS_CONFIRMED_ID ||
    site.SiteStatus.id === SITE_STATUS_DELISTED_ID ||
    site.SiteStatus.id === SITE_STATUS_DOES_NOT_QUALIFY
  ) {
    return buildNcgConfirmedDelistedDnqItems(site, history)
  }
  return buildNcgDefaultItems(site, history)
}

export function getNcgActionMenuItems(...args) {
  const [site, , history, setSiteToWorkWith, setSiteForDeleting] = args
  return buildNcgMenuItems({
    site,
    history,
    setSiteToWorkWith,
    setSiteForDeleting,
  })
}
